import { GridCell } from '@progress/kendo-react-grid'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Tooltip } from 'reactstrap';

export class PostTitleCell extends GridCell {

  private isOpen: boolean = false
  private maxLength: number = 500
  constructor(props: any) {
    super(props)
  }

  public render() {
    return <td>
      <div>
        <a id={`Title-${this.props.dataItem.id}`}
          href={this.props.dataItem.url}
          target="_blank" rel="noopener noreferrer">
          {this.props.dataItem.title || '<Article needs a title>'}
        </a>
        <Tooltip autohide={true} placement="right-end" toggle={this.toggle} isOpen={this.isOpen}
                                target={`Title-${this.props.dataItem.id}`}>
            <span>{this.description()}</span>
        </Tooltip>
      </div>
    </td>
  }

  private description(): string {
    if (isEmpty(this.props.dataItem.description)) {
      return '<no description>'
    } else {
      if (this.props.dataItem.description.length > this.maxLength) {
        const choppedWords = this.props.dataItem.description.substring(0, this.maxLength).split(' ')
        // Replace the last word (which is likely a partial) with ellipses (to represent "there's more")
        choppedWords[choppedWords.length - 1] = '...'
        return choppedWords.join(' ')
      } else {
        return this.props.dataItem.description
      }
    }
  }

  private toggle: () => any = () => {
    this.isOpen = !this.isOpen
    this.setState({ });
  }

}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/post_title_cell.tsx